<div class="field-container" [formGroup]="group">
  <label class="field-label" [for]="config.name">{{ config.label }}</label>
  <div class="field-row">
    <ng-container *ngIf="config.fieldConfig.inputType === 'audioFile'">
      <app-audio-uploader
        [fileListFormControlName]="config.name"
        [form]="group"
        [required]="config.required"
      ></app-audio-uploader>
    </ng-container>
    <ng-container *ngIf="config.fieldConfig.inputType === 'imageFile'">
      <app-image-uploader
        [currentImage]="currentImageFile"
        [fileListFormControlName]="config.name"
        [form]="group"
        [required]="config.required"
      ></app-image-uploader>
    </ng-container>
  </div>
  <ng-container *ngIf="formControl?.errors; else padding">
    <span
      class="error-container"
      [ngStyle]="{ visibility: formControl.touched ? 'inherit' : 'hidden' }"
    >
      {{ formControl?.errors | formError }}
    </span>
  </ng-container>
  <ng-template #padding>
    <span class="error-padding"></span>
  </ng-template>
</div>
